import { FC } from 'react'
import { Box, Typography } from '@mui/material'
import { IconButton } from './reportExportButton.styles'
import { LibraryDetailsHoverTooltip, PermissionTooltip } from 'ui/components/tooltip'
import ControlButton from '../sections/devices/components/ControlButton'
import theme from 'theme'
import { hasPermission, isViewerRole, Permission } from 'lib/utils'
import { ReportExportIcon } from 'ui/components/svg'
import { User } from '@frontegg/redux-store'

const popperProps = {
  sx: {
    marginTop: `-${theme.spacing.sm}px !important`
  }
}

interface ReportExportButtonProps {
  authUser: User | null | undefined
  isExporting: boolean
  showReport: boolean
  disabled: boolean
  handleExport: () => void
}

const ReportExportButton: FC<ReportExportButtonProps> = ({
  authUser,
  isExporting,
  showReport,
  disabled,
  handleExport
}) => {
  if (!showReport) return null
  const noPermission = isViewerRole(authUser) || !hasPermission(Permission.CPIConfigIntegrationView, authUser)

  if (noPermission) {
    return (
      <PermissionTooltip
        PopperProps={popperProps}
        title={
          <Box className="tooltip-wrapper-permissions">
            <Typography className="tooltip-text">Insufficient permissions</Typography>
          </Box>
        }
      >
        <IconButton disableTouchRipple>
          <ReportExportIcon />
        </IconButton>
      </PermissionTooltip>
    )
  }

  if (disabled) {
    return (
      <LibraryDetailsHoverTooltip title="Cannot download report">
        <IconButton disableTouchRipple>
          <ReportExportIcon />
        </IconButton>
      </LibraryDetailsHoverTooltip>
    )
  }

  return (
    <LibraryDetailsHoverTooltip title="Export PDF Report">
      <div>
        <ControlButton
          type="export-pdf"
          setAnchorEl={() => {
            //
          }}
          handleClick={handleExport}
          loading={isExporting}
        />
      </div>
    </LibraryDetailsHoverTooltip>
  )
}

export default ReportExportButton
